/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import styles from '../../../styles';

import Localized from '../../../../shared/components/Localized';
import Button from '../../../components/Button';

const Wrapper = styled.div`
`;

const Heading = styled.div`
  ${styles.fonts.headingMedium}
  font-weight: 300;
  margin-bottom: 1rem;
`;

const InputComponent = styled.div`
  margin-bottom: 1rem;
  width: 20rem;
`;

const Label = styled.div`
  ${styles.fonts.headingLabelCaps}
  margin-bottom: 0.25rem;
`;

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailAddress: ''
    };

    this.onEmailChange = this.onEmailChange.bind(this);
    this.submit = this.submit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  onEmailChange(event) {
    this.setState({ emailAddress: event.target.value });
  }

  onKeyPress(event) {
    if (event.key === 'Enter') {
      this.submit();
    }
  }

  submit() {
    this.props.loginRequest.handleRequest({ body: { emailAddress: this.state.emailAddress } });
  }

  render() {
    return (
      <Wrapper>
        <Heading><Localized modelKey='formHeading' modelAttribute='label' modelName='login' /></Heading>
        <InputComponent>
          <Label><Localized modelKey='emailAddress' modelAttribute='label' modelName='login' /></Label>
          <input className='slds-input'
            placeholder='email@example.com'
            value={this.state.emailAddress} onChange={this.onEmailChange} onKeyPress={this.onKeyPress} />
        </InputComponent>
        <Button theme='brand' onClick={this.submit}>
          <Localized modelKey='emailLinkLogin' modelAttribute='label' modelName='login' />
        </Button>
      </Wrapper>
    );
  }
}

export default Form;
